// Cliente de "Mi certificado" de firma electrónica (autoservicio,
// personal-medico / director-tecnico-farmacia) — ver
// packages/web/src/api/http-routes/hce-certificados.ts. Más simple que
// vaultClient.ts: el backend ya resuelve tenantSlug/hceUserId de la propia
// sesión (hceAutorizado), así que no hace falta mandarlos ni resolverlos acá.
import { base64DeBytes } from '../paciente/vaultClient';
import { vaultUrl } from './hceVault';
import { cabecerasBoveda } from './audit/auditedFetch';

export interface CertificadoFirma {
  id: number;
  titularNombre: string;
  cedulaCertificado: string;
  emisor: string;
  vigenteDesde: string;
  vigenteHasta: string;
  estado: 'activo' | 'reemplazado' | 'revocado';
  diasParaVencer: number;
  createdAt: string;
}

async function errorDeRespuesta(res: Response, accion: string): Promise<Error> {
  const cuerpo = await res.json().catch(() => ({}));
  return new Error(cuerpo.error || `${accion} (HTTP ${res.status}).`);
}

export async function listarCertificados(): Promise<CertificadoFirma[]> {
  const res = await fetch(vaultUrl('/api/hce/certificado'), { headers: cabecerasBoveda() });
  if (!res.ok) throw await errorDeRespuesta(res, 'No se pudo consultar el certificado');
  const cuerpo = await res.json();
  return Array.isArray(cuerpo.certificados) ? cuerpo.certificados : [];
}

export async function subirCertificado(input: { p12: Uint8Array; password: string }): Promise<CertificadoFirma> {
  const res = await fetch(vaultUrl('/api/hce/certificado'), {
    method: 'POST',
    headers: cabecerasBoveda(),
    body: JSON.stringify({ p12Base64: base64DeBytes(input.p12), password: input.password }),
  });
  if (!res.ok) throw await errorDeRespuesta(res, 'No se pudo vincular el certificado');
  const cuerpo = await res.json();
  return cuerpo.certificado;
}

export async function revocarCertificado(id: number): Promise<void> {
  const res = await fetch(vaultUrl(`/api/hce/certificado/${id}/revocar`), {
    method: 'POST',
    headers: cabecerasBoveda(),
  });
  if (!res.ok) throw await errorDeRespuesta(res, 'No se pudo revocar el certificado');
}
